(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/shared/hooks/use-remove-member.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/shared/hooks/use-remove-member.js');
'use strict';

const _React = React,
  useCallback = _React.useCallback;
const _svs$arena$store$team = svs.arena.store.teams.actions,
  removeMember = _svs$arena$store$team.removeMember,
  setTeamBalance = _svs$arena$store$team.setTeamBalance;
const deleteMemberAsync = svs.arena.service.teamsService.deleteMemberAsync;
const _svs$arena$pages$team = svs.arena.pages.teams.dialogs,
  showRemoveMemberQuestionDialog = _svs$arena$pages$team.showRemoveMemberQuestionDialog,
  showRemoveMemberError = _svs$arena$pages$team.showRemoveMemberError;

const useRemoveMember = function (teamId, teamName, customerId, firstName, lastName) {
  let amount = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  let isInactive = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  const dispatch = ReactRedux.useDispatch();
  const onRemoveMember = useCallback(async () => {
    if (await showRemoveMemberQuestionDialog(amount, teamName, firstName, lastName)) {
      const track = {
        category: 'spela-tillsammans',
        action: isInactive ? 'action_members_inactive' : 'action_members',
        opt_label: 'delete'
      };
      svs.components.analytics.trackEvent(track);
      const _await$deleteMemberAs = await deleteMemberAsync(teamId, customerId),
        error = _await$deleteMemberAs.error,
        data = _await$deleteMemberAs.data;
      if (error) {
        showRemoveMemberError(firstName);
        return;
      }
      const _data$syndicateAmount = data.syndicateAmounts,
        syndicateBalance = _data$syndicateAmount.syndicateBalance,
        playableAmount = _data$syndicateAmount.playableAmount;
      dispatch(removeMember({
        customerId,
        teamId
      }));
      dispatch(setTeamBalance({
        teamId,
        syndicateBalance,
        playableAmount,
        isMemberActive: false
      }));
    } else {
      const track = {
        category: 'spela-tillsammans',
        action: isInactive ? 'action_members_inactive' : 'action_members',
        opt_label: 'delete_cancel'
      };
      svs.components.analytics.trackEvent(track);
    }
  }, [amount, teamName, firstName, lastName, isInactive, teamId, customerId, dispatch]);
  return {
    onRemoveMember
  };
};
svs.arena.shared.hooks.useRemoveMember = useRemoveMember;

 })(window);